module.exports = __webpack_public_path__ + "img/logo.da125c69.png";